import {baseAxios} from '../helper/axiosHelper';

export const countryService = {
    getCountries,
    updateCountry,
    insertCountry,
    deleteCountry,
    getMwStForCountry,
    updateMwst,
    insertMwst,
    deleteMwst,
    getMwstAll
};

function getCountries() {

    return baseAxios.get('countries/countries/')
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function getMwStForCountry(country_fk) {

    return baseAxios.get('countries/mwst',{params:{country_fk:country_fk}})
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function getMwstAll() {

    return baseAxios.get('countries/mwst/all/')
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function updateCountry(data) {

    return baseAxios.put('countries/country',data )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function updateMwst(data) {

    return baseAxios.put('countries/mwst',data )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function insertCountry(data) {

    return baseAxios.post('countries/country',data )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function insertMwst(data) {

    return baseAxios.post('countries/mwst',data )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function deleteCountry(id) {

    return baseAxios.delete('countries/country',{params: {id: id}}  )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function deleteMwst(id) {

    return baseAxios.delete('countries/mwst',{params: {id: id}}  )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}